jQuery(document).ready(function ($) {
  // primary nav
  $('.nav-primary').accessibleNav({
    desktop: 1025,
    spans: 'show',
    level2position: 'vertical-bottom',
    level3position: 'horizontal-right'
  });

  $('.nav-toggle').on('keypress', function (e) {
    if (e.which === 13) {
      if ($('body').hasClass('nav-wrap-open')) {
        $('body').removeClass('nav-wrap-open');
      } else {
        $('body').addClass('nav-wrap-open');
        $('body').removeClass('search-open');
      }
    }
  });
  $('.nav-toggle').on('click', function () {
    if ($('body').hasClass('nav-wrap-open')) {
      $('body').removeClass('nav-wrap-open');
    } else {
      $('body').addClass('nav-wrap-open');
      $('body').removeClass('search-open');
    }
  });
  $('.search-toggle').on('keypress', function (e) {
    if (e.which === 13) {
      if ($('body').hasClass('search-open')) {
        $('body').removeClass('search-open');
      } else {
        $('body').addClass('search-open');
        $('body').removeClass('nav-wrap-open');
      }
    }
  });
  $('.search-toggle').on('click', function () {
    if ($('body').hasClass('search-open')) {
      $('body').removeClass('search-open');
    } else {
      $('body').addClass('search-open');
      $('body').removeClass('nav-wrap-open');
    }
  });

  // search
  $('.search-form > button').click(function (e) {
    e.preventDefault();
    var root = location.protocol + '//' + location.host + '/search-results?search=';
    var terms = $('.search-form input[type="search"]').val();
    var url = root + terms;
    // console.log(url);
    window.location.href = url;
  });
  $('.search-form input[type="search"]').on('keyup', function (e) {
    var root = location.protocol + '//' + location.host + '/search-results?search=';
    var terms = $(this).val();
    var url = root + terms;
    // console.log(url);
    if (e.which === 13) {
      window.location.href = url;
    }
  });
  $(".search-form input[type='search']").focusin(function () {
    $('.search-form').addClass('active');
  });
  $(".search-form input[type='search']").focusout(function () {
    $('.search-form').removeClass('active');
  });

  // add class to select on open
  $('select').on('click', function () {
    $(this).toggleClass('open');
  });
  $('label').on('click', function (e) {
    if ($(this).next().is('select')) {
      e.preventDefault();
      $(this).next('select').focus();
    }
  });
  $(document).on('keyup', function (e) {
    if (e.keyCode === 27) {
      if ($('select').hasClass('open')) {
        $(this).removeClass('open');
      }
    }
  });

  $(document, 'body').scroll(function () {
    var scrollUpper = 200;
    var scrollLower = 100;
    var scroll = ((document.body.scrollTop == 0) ? $(window).scrollTop() : document.body.scrollTop);
    if (scroll >= scrollLower && scroll <= scrollUpper) {
      $("header").addClass("stuck");
      $('header').removeClass('show');
    } else if (scroll < scrollLower) {
      $("header").removeClass('stuck');
      $('header').removeClass('show');
    } else if (scroll >= scrollUpper) {
      $('header').addClass('show');
    }
  });

  $('body').on('click', '.custom-select h3', function () {
    $(this).toggleClass('open');
    $(this).next('ul').toggleClass('open');
  });

  $('body').on('keyup', '.custom-select h3', function (e) {
    if (e.which === 13) {
      $(this).toggleClass('open');
      $(this).next('ul').toggleClass('open');
    } else if (e.which === 27) {
      $(this).removeClass('open');
      $(this).next('ul').removeClass('open');
    }
  });

  $('body').on('keyup', '.custom-select a', function (e) {
    var selToggler = $(this).parents('ul').siblings('h3');
    if (e.which === 27) {
      selToggler.removeClass('open');
      selToggler.next('ul').removeClass('open');
    }
  });

  $('.print-link').on('click', function (e) {
    e.preventDefault();
    window.print();
  });

});

(function ($) {
  $.fn.textfill = function (maxFontSize, minFontSize) {
    maxFontSize = parseInt(maxFontSize, 10);
    minFontSze = parseInt(minFontSize, 10);
    return this.each(function () {
      var ourText = $("span", this),
        parent = ourText.parent(),
        maxHeight = parent.height(),
        maxWidth = parent.width(),
        fontSize = parseInt(ourText.css("fontSize"), 10),
        multiplier = maxWidth / ourText.width(),
        newSize = (fontSize * (multiplier));

      if (maxFontSize > 0 && newSize > maxFontSize) {
        newSize = maxFontSize;
      } else if (minFontSize > 0 && newSize < minFontSize) {
        newSize = minFontSize;
      }
      ourText.css(
        "fontSize", newSize
      );
    });
  };
})(jQuery);